import React from "react";
import { PortalSetPasswordForm } from "./PortalSetPasswordForm";

export default function PortalFirstAccess() {
  return (
    <PortalSetPasswordForm
      title="Primeiro acesso"
      subtitle="Defina sua senha para acessar o portal."
      endpoint="/portal/auth/first-access"
      successMessage="Senha definida com sucesso — você já pode entrar."
    />
  );
}
